<template>
    <v-container fluid class="ma-0 pa-0 login-bg">
        <MFASVG :class="[this.$vuetify.breakpoint.smAndDown ? 'mfaSVG-mobile' : 'mfaSVG']"
                :rectColor="loginSVGColors.rectColor"
                :stopColor1="loginSVGColors.stopColor1"
                :stopColor2="loginSVGColors.stopColor2"
                :stopColor3="loginSVGColors.stopColor3"
                :circleColor1="loginSVGColors.circleColor1"
                :circleColor2="loginSVGColors.circleColor2">

        </MFASVG>
        <v-row>
            <v-toolbar flat>
                <v-hover v-slot="{hover}">
                    <v-btn @click="toggleLocale" class="text-none text-normal min-height-1" text absolute right plain :color="hover ? 'linkHover' : 'primary'">{{$t('forgot-password.locale')}}</v-btn>
                </v-hover>
            </v-toolbar>
        </v-row>
        <v-row>
            <v-col>
                <v-row align="center" justify="center" class="py-16">
                    <v-col align="center">
                        <v-card class="my-auto rounded-xl"
                                :class="isMobile ? ['pt-4'] : ['pt-8']"
                                max-width="500px"
                                flat>
                            <v-img class="mx-auto px-5 login-logo"
                                   :src="`../../assets/Branding/${this.$experience.key}/Images/${getLogo}`"
                                   max-width="270px"
                                   contain>
                            </v-img>
                            <v-card-text>
                                <v-stepper v-model="step" flat>
                                    <v-stepper-items>
                                        <v-stepper-content class="pa-0" step="1">
                                            <v-container>
                                                <v-subheader class="card-title d-block py-0 text-center">{{$t('register.title')}}</v-subheader>
                                                <v-row class="pa-0 ma-0" justify="center">
                                                    <v-alert v-if="this.step1ErrorMsg" class="mx-2 pa-3 d-inline-block" dense dark type="error">{{$t(this.step1ErrorMsg)}}</v-alert>
                                                </v-row>
                                                <v-form ref="step1Form" v-model="step1Valid">
                                                    <!--<v-subheader class="d-block py-0 text-center card-subtitle">{{$t('register.subTitle')}}</v-subheader>-->
                                                    <v-text-field v-model="registerViewModel.firstName"
                                                                  :label="$t('register.firstName')"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  maxlength="100"
                                                                  class="text-normal min-height-1 mb-2"
                                                                  :rules="firstNameRules"></v-text-field>
                                                    <v-text-field v-model="registerViewModel.lastName"
                                                                  :label="$t('register.lastName')"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  maxlength="100"
                                                                  class="text-normal min-height-1 mb-2"
                                                                  :rules="lastNameRules"></v-text-field>
                                                    <v-text-field v-model="registerViewModel.email"
                                                                  :label="$t('register.email')"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  maxlength="255"
                                                                  class="text-normal min-height-1 mb-2"
                                                                  :rules="emailRules"></v-text-field>
                                                    <!--<v-subheader class="d-block py-0 text-center subtitle-2 font-weight-black">{{$t('register.subTitle2')}}</v-subheader>-->
                                                    <v-text-field v-model="registerViewModel.userName"
                                                                  :label="$t('register.userName')"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  maxlength="50"
                                                                  class="text-normal min-height-1 mb-2"
                                                                  :rules="usernameRules"></v-text-field>
                                                    <v-text-field v-model="registerViewModel.password"
                                                                  :label="$t('register.password')"
                                                                  :type="passwordVisible ? 'text' : 'password'"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  class="text-normal min-height-1 mb-2"
                                                                  maxlength="30"
                                                                  :rules="passwordRules"
                                                                  :append-icon="passwordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                                                  @click:append="passwordVisible = !passwordVisible"></v-text-field>
                                                    <v-text-field v-model="registerViewModel.confirmPassword"
                                                                  :label="$t('register.passwordConfirmation')"
                                                                  :type="passwordConfirmationVisible ? 'text' : 'password'"
                                                                  outlined
                                                                  hide-details
                                                                  required
                                                                  maxlength="30"
                                                                  class="text-normal min-height-1 mb-2"
                                                                  :rules="passwordConfirmationRules"
                                                                  :append-icon="passwordConfirmationVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                                                  @click:append="passwordConfirmationVisible = !passwordConfirmationVisible"></v-text-field>
                                                </v-form>
                                                <v-row class="my-1 px-3">
                                                    <span class="text-small font-weight-bold">{{$t('register.bottomTextBold')}}</span>
                                                    <span class="text-small text-left">{{$t('register.bottomText')}}</span>
                                                </v-row>
                                                <v-row class="px-3">
                                                    <v-hover v-slot="{hover}">
                                                        <v-btn class="text-none text-normal min-height-1"
                                                               block
                                                               :disabled="!isStep1ButtonActive"
                                                               :dark="isStep1ButtonActive"
                                                               depressed
                                                               :color="hover ? 'buttonHover' : 'primary'"
                                                               @click="onNext"
                                                               min-width="150px">
                                                            {{$t('register.next')}}
                                                            &nbsp;
                                                            <v-progress-circular v-if="formProcess" indeterminate
                                                                                 color="primary">
                                                            </v-progress-circular>
                                                        </v-btn>
                                                    </v-hover>
                                                </v-row>
                                                <v-row class="px-3" align="center">
                                                    <span class="text-small">{{$t('register.haveAccount')}}</span>
                                                    <v-hover v-slot="{hover}">
                                                        <v-btn class="text-none text-small pl-1" text plain :color="hover ? 'linkHover' : 'primary'" to="/login">{{$t('register.signIn')}}</v-btn>
                                                    </v-hover>
                                                </v-row>
                                            </v-container>
                                        </v-stepper-content>
                                        <v-stepper-content class="pa-0" step="2">
                                            <v-container>
                                                <v-subheader class="py-0 d-block text-center card-title">{{$t('register.mfaTitle')}}</v-subheader>
                                                <v-subheader class="py-0 text-center card-subtitle">{{$t('register.mfaSubTitle', { email: registerViewModel.email })}}</v-subheader>
                                                <v-row class="pa-0 ma-0" justify="center">
                                                    <v-alert v-if="this.step2ErrorMsg" class="mx-4 pa-3 d-inline-block" dense dark type="error">{{$t(this.step2ErrorMsg)}}</v-alert>
                                                    <v-alert v-if="this.codeResend" class="mx-4 pa-3 d-inline-block" dense dark type="success">{{$t('register.contact-validation-code-resend')}}</v-alert>
                                                </v-row>
                                                    <v-form ref="step2Form" v-model="step2Valid">

                                                    <v-row class="mt-4">
                                                        <v-row>
                                                            <v-otp-input length="7"
                                                                         type="number"
                                                                         class="mx-6"
                                                                         :class="this.$vuetify.breakpoint.smAndDown ? 'v-otp-input-mobile' : ''"
                                                                         :rules="validationCodeRules"
                                                                         @finish="onFinish">

                                                            </v-otp-input>
                                                        </v-row>
                                                    </v-row>
                                                    <v-row class="d-flex justify-space-between mt-3">
                                                        <v-hover v-slot="{hover}">
                                                            <v-btn class="text-none text-small" text plain :color="hover ? 'linkHover' : 'primary'" @click="resendCode">{{$t('login.mfaResendCode')}}</v-btn>
                                                        </v-hover>
                                                    </v-row>
                                                    <v-row class="my-3">
                                                        <v-hover v-slot="{hover}">
                                                            <v-btn class="text-none text-small" text plain :color="hover ? 'linkHover' : 'primary'" to="/login">{{$t('login.mfaReturnToLogin')}}</v-btn>
                                                        </v-hover>
                                                    </v-row>

                                                    <v-row justify="space-between" class="mx-0">
                                                        <v-hover v-slot="{hover}">
                                                            <v-btn class="text-none text-normal min-height-1"
                                                                   dark
                                                                   depressed
                                                                   :color="hover ? 'buttonHover' : 'primary'"
                                                                   @click="step = 1"
                                                                   :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                {{$t('register.previous')}}
                                                            </v-btn>
                                                        </v-hover>
                                                        <v-hover v-slot="{hover}">
                                                            <v-btn class="text-none text-normal min-height-1"
                                                                   :disabled="!isStep2ButtonActive"
                                                                   :dark="isStep2ButtonActive"
                                                                   depressed
                                                                   :color="hover ? 'buttonHover' : 'primary'"
                                                                   @click="onNextStep2"
                                                                   :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                {{$t('register.next')}}
                                                                &nbsp;
                                                                <v-progress-circular v-if="formProcess" indeterminate
                                                                                     color="primary">
                                                                </v-progress-circular>
                                                            </v-btn>
                                                        </v-hover>
                                                    </v-row>

                                                </v-form>
                                            </v-container>
                                            </v-stepper-content>
                                                <v-stepper-content class="pa-0" step="3">
                                                    <v-container>
                                                        <v-subheader class="card-title d-block py-0 text-center">{{$t('register.titleStep3')}}</v-subheader>
                                                        <v-subheader class="card-title d-block py-0 text-center">{{$t('register.subTitleStep3')}}</v-subheader>
                                                        <v-row class="pa-0 ma-0" justify="center">
                                                            <v-alert v-if="this.step3ErrorMsg"
                                                                     class="mx-2 pa-3 d-inline-block"
                                                                     dense
                                                                     dark
                                                                     type="error">{{$t(this.step3ErrorMsg)}}</v-alert>
                                                        </v-row>
                                                        <v-form ref="step3Form">

                                                            <v-list flat class="mb-2" v-model="registerViewModel.reportsLst">
                                                                <v-list-item v-for="(report) in registerViewModel.reportsLst"
                                                                             :key="report.Id"
                                                                             class="px-0">
                                                                    <template>
                                                                        <div class="list-item my-1">
                                                                            <v-row align="center" class="mx-2">
                                                                                <v-list-item-action>
                                                                                    <v-checkbox v-model="report.Checked" @change="updateStep3Valid()"></v-checkbox>
                                                                                </v-list-item-action>
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title class="text-normal text-left">{{reportTitle(report)}}</v-list-item-title>
                                                                                </v-list-item-content>
                                                                            </v-row>
                                                                        </div>
                                                                    </template>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-form>

                                                        <v-row class="mx-0">
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-small pl-1 min-height-1" text plain :color="hover ? 'linkHover' : 'primary'" to="/login">{{$t('register.returnToLogin')}}</v-btn>
                                                            </v-hover>
                                                        </v-row>
                                                        <v-row justify="space-between" class="mx-0">
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-normal min-height-1"
                                                                       dark
                                                                       depressed
                                                                       :color="hover ? 'buttonHover' : 'primary'"
                                                                       @click="step = 1"
                                                                       :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                    {{$t('register.previous')}}
                                                                </v-btn>
                                                            </v-hover>
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-normal min-height-1"
                                                                       :disabled="!isStep3ButtonActive"
                                                                       :dark="isStep3ButtonActive"
                                                                       depressed
                                                                       :color="hover ? 'buttonHover' : 'primary'"
                                                                       @click="onNextStep3"
                                                                       :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                    {{$t('register.next')}}
                                                                    &nbsp;
                                                                    <v-progress-circular v-if="formProcess" indeterminate
                                                                                         color="primary">
                                                                    </v-progress-circular>
                                                                </v-btn>
                                                            </v-hover>
                                                        </v-row>
                                                    </v-container>
                                                </v-stepper-content>
                                                <v-stepper-content class="pa-0" step="4">
                                                    <v-container class="px-0">
                                                        <v-subheader class="card-title d-block py-0 text-center">{{$t('register.titleStep4')}}</v-subheader>
                                                        <v-subheader class="card-title d-block py-0 text-center">{{$t('register.subTitleStep4')}}</v-subheader>
                                                        <v-row class="pa-0 ma-0" justify="center">
                                                            <v-alert v-if="this.step4ErrorMsg" class="mx-2 pa-3 d-inline-block" dense dark type="error">
                                                                <span v-html="step4ErrorMessage" />
                                                            </v-alert>
                                                        </v-row>
                                                        <v-form ref="step4Form"
                                                                v-model="step4Valid">

                                                            <v-list flat
                                                                    class="ma-0 pa-0">
                                                                <template v-for="(report) in registerViewModel.choosenReports">
                                                                    <v-list-item :key="report.Id"
                                                                                 class="ma-0 pa-0">
                                                                        <v-card outlined width="100%" class="mx-3 my-1 rounded-lg">
                                                                            <v-list-item-content class="ma-0 pa-0">
                                                                                <v-subheader class="text-normal py-0 font-weight-bold">{{reportTitle(report)}}</v-subheader>
                                                                                <v-list flat
                                                                                        class="mb-1">
                                                                                    <v-list-item v-for="(attribute) in report.Attributes"
                                                                                                 :key="attribute.AttributeId"
                                                                                                 class="mx-4 pa-0 d-block">
                                                                                        <v-row class="ma-0 pt-3" align="center">
                                                                                            <v-text-field v-model="attribute.Value"
                                                                                                          :label="attributeName(attribute)"
                                                                                                          class="text-normal min-height-1  mb-2"
                                                                                                          outlined
                                                                                                          required
                                                                                                          hide-details
                                                                                                          maxlength="255"
                                                                                                          :rules="requiredRules"
                                                                                                          @input="clearStep4ErrorMsg"></v-text-field>
                                                                                        </v-row>
                                                                                        <v-row v-if="attribute.DescriptionFr" class="ma-0 pa-0" align="center">
                                                                                            <span class="text-small text-left mx-2">{{$i18n.locale == 'fr' ? attribute.DescriptionFr : attribute.DescriptionEn}}</span>
                                                                                        </v-row>
                                                                                    </v-list-item>
                                                                                </v-list>
                                                                            </v-list-item-content>
                                                                        </v-card>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-list>
                                                        </v-form>

                                                        <v-row class="mx-3">
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-small pl-1 min-height-1" text plain :color="hover ? 'linkHover' : 'primary'" to="/login">{{$t('register.returnToLogin')}}</v-btn>
                                                            </v-hover>
                                                        </v-row>
                                                        <v-row justify="space-between" class="mx-3">
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-normal min-height-1"
                                                                       dark
                                                                       depressed
                                                                       :color="hover ? 'buttonHover' : 'primary'"
                                                                       @click="step = 3"
                                                                       :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                    {{$t('register.previous')}}
                                                                </v-btn>
                                                            </v-hover>
                                                            <v-hover v-slot="{hover}">
                                                                <v-btn class="text-none text-normal min-height-1"
                                                                       :disabled="!isStep4ButtonActive"
                                                                       :dark="isStep4ButtonActive"
                                                                       depressed
                                                                       :color="hover ? 'buttonHover' : 'primary'"
                                                                       @click="onNextStep4(false)"
                                                                       :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                                    {{$t('register.signUp')}}
                                                                    &nbsp;
                                                                    <v-progress-circular v-if="formProcess" indeterminate
                                                                                         color="primary">
                                                                    </v-progress-circular>
                                                                </v-btn>
                                                            </v-hover>
                                                        </v-row>
                                                    </v-container>
                                                </v-stepper-content>
                                        </v-stepper-items>
                                </v-stepper>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog v-model="userDuplicateFlow" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="warning"
                            class="my-5">mdi-alert-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ $t('register.duplicateUserDataError') }}</v-card-subtitle>
                <v-card-subtitle class="text-center card-subtitle2 font-weight-medium mt-1">{{ $t('register.continueWithDupes') }}</v-card-subtitle>
                <v-card-actions>
                    <v-row v-if="!blockDuplicate" justify="space-between">
                        <v-btn class="text-normal" depressed color="primary" x-large @click="userDuplicateFlow = false">{{$t('cancel')}}</v-btn>
                        <v-btn class="text-normal" depressed color="warning" x-large @click="onNextStep4(true); ">{{$t('continue')}}</v-btn>
                    </v-row>
                    <v-row v-if="blockDuplicate" justify="center">
                        <v-btn class="text-normal" depressed color="primary" x-large @click="userDuplicateFlow = false">{{$t('ok')}}</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { apiService } from "../../services";
    import { mapState, mapActions } from "vuex";
    import MFASVG from '../../components/2FA_SVG.vue';
    import {
        emailRules,
        passwordRules,
        passwordConfirmationRules,
        usernameRules,
        firstNameRules,
        lastNameRules,
        validationCodeRules
    } from '../../utils/validationRules';

    export default {
        name: "register",
        components: { MFASVG },
        data() {
            return {
                registerViewModel: {
                    firstName: undefined,
                    lastName: undefined,
                    email: undefined,
                    userName: undefined,
                    password: undefined,
                    confirmPassword: undefined,
                    choosenReports: [],
                    reportsLst: [],
                },
                validationCode: '',
                step: 1,
                step1Valid: false,
                step1ErrorMsg: "",
                step2Valid: false,
                step2ErrorMsg: "",
                step3Valid: false,
                step3ErrorMsg: "",
                step3ReportErrorList: [],
                step4Valid: false,
                step4ErrorMsg: "",
                step4ReportErrorList: [],
                codeResend: false,

                // Enhanced validation rules for WCAG AA (3.3.3)
                usernameRules: usernameRules(this.$t.bind(this)),
                firstNameRules: firstNameRules(this.$t.bind(this)),
                lastNameRules: lastNameRules(this.$t.bind(this)),
                emailRules: emailRules(this.$t.bind(this)),
                passwordRules: passwordRules(this.$t.bind(this)),
                validationCodeRules: validationCodeRules(this.$t.bind(this), 7),
                requiredRules: [
                    v => !!v || this.$t('validation.fieldRequired')
                ],

                logo: "",
                passwordConfirmationVisible: false,
                passwordVisible: false,
                formProcess: false,
                userDuplicateFlow: false,
                blockDuplicate: false
            }
        },
        computed: {
            ...mapState("account", ["status", "user"]),
            ...mapState({ alert: state => state.alert }),

            loginSVGColors() {
                return this.$vuetify.theme.themes.light.loginSVG;
            },
            isStep1ButtonActive() {
                return !this.formProcess && this.step1Valid ;
            },
            isStep2ButtonActive() {
                return !this.formProcess && this.step2Valid;
            },
            isStep3ButtonActive() {
                return !this.formProcess && this.step3Valid;
            },
            isStep4ButtonActive() {
                return !this.formProcess && this.step4Valid && !this.step4ErrorMsg;
            },
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            step4ErrorMessage() {
                let msg = '';
                msg = this.$t(this.step4ErrorMsg);
                if (this.step4ReportErrorList)
                    for (let i = 0; i < this.step4ReportErrorList.length; i++) {
                        let report = this.registerViewModel.choosenReports.find(r => r.Id == this.step4ReportErrorList[i]);
                        msg += '<br/>' + this.reportTitle(report);
                    }
                    
                return msg;
            },
            getLogo() {
                return (this.$i18n.locale == 'en' && this.$experience.logoLoginEN != null) ? this.$experience.logoLoginEN : this.$experience.logo;
            },
            // Computed password confirmation rules (needs dynamic access to password)
            passwordConfirmationRules() {
                return passwordConfirmationRules(this.$t.bind(this), this.registerViewModel.password);
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            ...mapActions("account", ["login"]),
            toggleLocale() {
                this.$emit("toggleLocale");
            },
            fieldRequired(val) {
                return this.$t('register.fieldRequired', { field: this.$t(val) });
            },
            textLengthRule(fieldName, n) {
                return this.$t('register.textLengthRule', { field: this.$t(fieldName), n: n })
            },
            onNext() {
                this.step1ErrorMsg = "";
                this.step2Valid = false;
                this.$refs.step1Form.validate();
                if (this.step1Valid) {
                    this.formProcess = true;
                    apiService.validateRegistrationStep1(this.registerViewModel)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                if (response.data.reportsLst) {
                                    this.registerViewModel.reportsLst = response.data.reportsLst
                                    this.registerViewModel.reportsLst.forEach((report) => {
                                        report.Checked = true;
                                    });
                                }
                                this.step1ErrorMsg = "";
                                this.step2ErrorMsg = "";
                                this.step = 2;
                            }
                        })
                        .catch((error) => {
                            this.formProcess = false;
                            this.step1ErrorMsg = error;
                        })
                }
            },
            onNextStep2() {
                this.step2ErrorMsg = "";
                this.codeResend = false;
                this.$refs.step2Form.validate();
                if (this.step2Valid) {
                    this.formProcess = true;
                    const data = {
                        data: this.registerViewModel,
                        contactValidationCode: this.validationCode,
                    }
                    apiService.validateRegistrationStep2(data)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                if (response.data.reportsLst) {
                                    this.registerViewModel.reportsLst = response.data.reportsLst
                                    this.registerViewModel.reportsLst.forEach((report) => {
                                        report.Checked = true;
                                    });
                                    this.updateStep3Valid();
                                }
                                this.step3ErrorMsg = "";
                                this.step = 3;
                            }
                        })
                        .catch((error) => {
                            this.formProcess = false;
                            this.step2ErrorMsg = error;
                        })
                }
            },
            clearStep4ErrorMsg() {
                this.step4ErrorMsg = "";
            },
            updateStep3Valid() {
                let valid = false;
                for (let i = 0; i < this.registerViewModel.reportsLst.length; i++) {
                    valid = valid || this.registerViewModel.reportsLst[i].Checked;
                }
                this.step3Valid = valid;
            },
            onNextStep3() {
                this.step3ErrorMsg = "";
                this.$refs.step3Form.validate();
                if (this.step3Valid) {
                    this.formProcess = true;
                    apiService.validateRegistrationStep3(this.registerViewModel)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                this.registerViewModel.choosenReports = response.data.choosenReports;
                                this.step3ErrorMsg = "";
                                this.step4ErrorMsg = "";
                                this.step4ReportErrorList = "";
                                this.step = 4;
                            }
                        })
                        .catch((error) => {
                            this.formProcess = false;
                            this.step3ErrorMsg = error;
                        })
                }
            },
            onNextStep4(ignoreDupes) {
                this.step4ErrorMsg = "";
                this.step4ReportErrorList = "";
                this.$refs.step4Form.validate();
                this.userDuplicateFlow = false;
                if (this.step4Valid) {
                    this.formProcess = true;
                    apiService.processRegistering(this.registerViewModel, ignoreDupes)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                this.step4ErrorMsg = "";
                                this.login({ username: response.data.data.Username, password: response.data.data.Password });
                            }
                        })
                        .catch((error) => {
                            this.formProcess = false;
                            if (error.msg === 'register.duplicateUserDataError') {
                                this.blockDuplicate = error.blockDuplicate;
                                this.userDuplicateFlow = true;
                                
                            } else {
                                this.step4ErrorMsg = error.msg;
                                this.step4ReportErrorList = error.reportErrorList;
                            }
                        })
                }
            },
            resendCode() {
                this.validationCode = '';
                apiService.resendCode(this.registerViewModel)
                    .then((response) => {
                        if (response.data.success)
                            this.codeResend = true;
                        else
                            this.step2ErrorMsg = this.$t('register.error-sending-validation-code');
                    });
            },
            reportTitle(report) {
                if (this.$i18n.locale == "fr") {
                    return report.TitleFr;
                } else {
                    return report.TitleEn;
                }
            },
            attributeName(attribute) {
                if (this.$i18n.locale == "fr") {
                    return attribute.NameFr;
                } else {
                    return attribute.NameEn;
                }
            },
            onFinish(code) {
                this.validationCode = code;
            }
        },
        watch: {
            $route() {
                // clear alert on location change
                this.clearAlert();
            },
        }
    }
</script>

<style scoped>
    .login-logo {
        margin-top: 50px !important;
        margin-bottom: 50px !important;
    }

    .mfaSVG {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 50%;
    }

    .mfaSVG-mobile {
        position: absolute;
        top: 48px;
        width: 100%;
        height: 50%;
    }

    .list-item {
        border: 1px solid;
        border-radius: 10px;
        min-height: 67px;
        min-width: 100%;
        display: flex;
        align-items: center;
        border-color: darkgray;
    }
    .list-item:hover {
        border-color: black;
    }

    .v-otp-input >>> input {
        font-size: 40px !important;
        min-height: 87px !important;
        border-radius: 10px;
        text-align: center !important;
    }

    .v-otp-input-mobile >>> input {
        font-size: 20px !important;
        min-height: 48px !important;
        border-radius: 5px;
        text-align: center !important;
    }
</style>
